import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      color: 'var(--x-white)',
      borderRadius: 72,
      backgroundColor: 'var(--x-new-label-color)',
      fontWeight: 600,
    },
    small: {
      fontSize: 10,
      lineHeight: '14px',
      padding: [1, 6],
    },
    medium: {
      fontSize: 12,
      lineHeight: '18px',
      padding: [3, 12],
    },
  },
  {
    name: 'NewLabel',
  },
);

export default useStyles;
